export const PAGE = {
  NONE: Symbol('NONE'),
  LOGIN: Symbol('LOGIN'),
  CHECK_PAGE: Symbol('CHECK_PAGE'),
  FORGOT: Symbol('FORGOT'),
  FORGOT_SEND: Symbol('FORGOT_SEND'),
  RESET_PASSWORD: Symbol('RESET_PASSWORD'),
  RESET_PASSWORD_DONE: Symbol('RESET_PASSWORD_DONE'),
  BROWSER_NOT_SUPPORTED: Symbol('BROWSER_NOT_SUPPORTED'),
};
